// src/components/HeroSection.jsx
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";

export default function HeroSection() {
  return (
    <section className="bg-green-50 py-12 px-6">
      <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-10">
        {/* Doctor Image */}
        <img
  src="/images/doctor_image_1.jpg"
  alt="Dr. Nidhi Malviya"
  className="w-64 h-64 rounded-full shadow-xl object-contain border-4 border-white bg-white"
/>


        {/* Doctor Info */}
        <div className="text-center lg:text-left space-y-4">
          <h2 className="text-3xl font-bold text-green-800">
            Dr. Nidhi Malviya (BHMS, CCH, CGO)
          </h2>
          <p className="text-gray-700 italic">
            Specialized in a holistic approach to health and wellness
          </p>

          <div className="space-y-2 text-lg text-gray-800">
            <div className="flex items-center gap-3 justify-center lg:justify-start">
              <FaPhoneAlt className="text-green-600" />
              <a href="tel:+918319789552" className="hover:underline">
                +91 83197 89552
              </a>
            </div>
            <div className="flex items-center gap-3 justify-center lg:justify-start">
              <FaEnvelope className="text-green-600" />
              <a
                href="mailto:drnidhimalviya19@gmail.com"
                className="hover:underline"
              >
                drnidhimalviya19@gmail.com
              </a>
            </div>
            <div className="flex items-center gap-3 justify-center lg:justify-start">
              <FaMapMarkerAlt className="text-green-600" />
              <a
                href="https://g.co/kgs/wUVTd2p"
                target="_blank"
                rel="noreferrer"
                className="hover:underline"
              >
                Shop No- G-3, Udai Nagar, Near Elite Anmol Apartment, Indore
              </a>
            </div>
            <div className="flex items-center gap-3 justify-center lg:justify-start">
              <FaClock className="text-green-600" />
              <span>
                Mon–Sat: 10 AM – 1 PM, 5 PM – 8 PM | Sun: 10 AM – 1 PM
              </span>
            </div>
          </div>

          {/* CTA Button */}
          <div className="pt-4">
            <a
              href="https://g.co/kgs/wUVTd2p"
              target="_blank"
              rel="noreferrer"
              className="inline-block bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition"
            >
              📍 Visit Google Page
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
